import { render, staticRenderFns } from "./security_guard_messages.vue?vue&type=template&id=6a17487b&scoped=true"
import script from "./security_guard_messages.vue?vue&type=script&lang=js"
export * from "./security_guard_messages.vue?vue&type=script&lang=js"
import style0 from "./security_guard_messages.vue?vue&type=style&index=0&id=6a17487b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a17487b",
  null
  
)

export default component.exports